const API_URL = process.env.REACT_APP_API_URL;

export const getPresupuestos = async () => {
  const response = await fetch(`${API_URL}/presupuestos`);

  if (!response.ok) {
    throw new Error("Error al obtener presupuestos");
  }

  return response.json();
};

export const getPresupuestoById = async (id_presupuesto) => {
  const response = await fetch(`${API_URL}/presupuestos/${id_presupuesto}`);

  if (!response.ok) {
    throw new Error("Error al obtener presupuesto");
  }

  return response.json();
};

export const createPresupuesto = async (presupuesto) => {
  const response = await fetch(`${API_URL}/presupuestos`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(presupuesto),
  });

  if (!response.ok) {
    throw new Error("Error al crear presupuesto");
  }

  return response.json();
};

export const updatePresupuesto = async (id_presupuesto, presupuesto) => {
  const response = await fetch(`${API_URL}/presupuestos/${id_presupuesto}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(presupuesto),
  });

  if (!response.ok) {
    throw new Error("Error al actualizar presupuesto");
  }

  return response.json();
};

export const deletePresupuesto = async (id_presupuesto) => {
  const response = await fetch(`${API_URL}/presupuestos/${id_presupuesto}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Error al eliminar presupuesto");
  }

  return response.json();
};